// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"509":"fa5392ed","821":"5a1dc157"}[chunkId] + ".chunk.js";
};